import React, { useRef, useState, useEffect, useMemo } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import { BiScan } from "react-icons/bi";
import { FiBox } from "react-icons/fi";
import { GoPackageDependents } from "react-icons/go";
import { LuPackage, LuPackageCheck, LuSearch } from "react-icons/lu";
import { QrScanner } from "@yudiel/react-qr-scanner";
import Snackbar from "../../../common/Snackbar";
import {
  getBagManagementFiltersStatistics,
  getBagManagementParticipants,
  getBagManagementParticipantsActivities,
  getBagManagementParticipantsDropQuantities,
  getBagManagementParticipantsInfo,
  postBagManagementScannedData,
} from "../../../../apis/eventService";
import ApplicationUtil from "../../../../utils/ApplicationUtil";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import moment from "moment";

/* ----- small reusable Confirm Modal ----- */
function ConfirmModal({ open, onClose, runner, action, time, onConfirm }) {
  const [qty, setQty] = useState(1);

  const [dropQuantities, setDropQuantities] = useState();

  useEffect(() => {
    const eventId = ApplicationUtil.getRunnersEventID();
    if (runner && open) {
      fetchRunnerDropQuantities(eventId, runner.runnerId).then((res) => {
        if (res.success) {
          console.log(res, "droquanties");

          // parsed = res.data[0];
          setDropQuantities(res.data?.dropQuantity);
        }
      });
    }
  }, [open]);

  const fetchRunnerDropQuantities = async (eventId, runnerId) => {
    try {
      const response = await getBagManagementParticipantsDropQuantities(
        eventId,
        runnerId
      );
      return {
        success: true,
        data: response?.data || null,
      };
    } catch (error) {
      console.log("Error fetching runner info", error);
      return {
        success: false,
        error,
      };
    }
  };

  // useEffect(() => {
  //   if (!open) setQty(1);
  // }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 420,
          maxWidth: "95%",
          background: "#fff",
          borderRadius: 8,
          padding: 18,
          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        }}
      >
        <div style={{ fontWeight: 700, marginBottom: 8 }}>Action: {action}</div>
        <div style={{ color: "#6b7280", marginBottom: 8 }}>
          Participant:{" "}
          {runner.name
            ? runner.name
            : runner?.firstName + " " + runner?.lastName || "-"}
        </div>
        {/* <div style={{ color: "#6b7280", marginBottom: 8 }}>
          Bib: {runner?.bibNumber || "-"}
        </div> */}

        {action === "Pickup" && dropQuantities === 0 && (
          <div style={{ color: "#6b7280", marginBottom: 8 }}>
            No bags were dropped.
          </div>
        )}
        {action === "Pickup" && dropQuantities < 0 && (
          <div style={{ color: "#6b7280", marginBottom: 8 }}>
            Bags already picked up.
          </div>
        )}
        <div
          style={{
            flex: 1,
            height: 1,
            background: "#f0f1f2",
            marginBottom: "10px",
          }}
        ></div>
        <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
          <div style={{ flex: 1, gap: 4 }}>
            <div style={{ color: "#6b7280", fontSize: 14 }}>Time</div>
            <div style={{ fontWeight: 700 }}>{time}</div>
          </div>
          {action !== "Scan" && (
            <div style={{ flex: 1, gap: 3 }}>
              {action === "Pickup" ? (
                <div>
                  {" "}
                  Previously dropped:{" "}
                  <strong>
                    {dropQuantities > 0 ? dropQuantities : 0} Bags
                  </strong>
                </div>
              ) : (
                <>
                  <div style={{ color: "#6b7280", fontSize: 14 }}>
                    Bag quantity
                  </div>
                  <select
                    value={qty}
                    disabled={action === "Scan" || action === "Pickup"}
                    onChange={(e) => {
                      setQty(Number(e.target.value));
                    }}
                    style={{
                      width: "100%",
                      padding: "8px 10px",
                      borderRadius: 8,
                      border: "1px solid #cfd2d6",
                      marginTop: 6,
                    }}
                  >
                    {Array.from({ length: 2 }).map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </>
              )}
            </div>
          )}
        </div>
        {action !== "Scan" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginVertical: "10px",
            }}
          >
            <button
              onClick={onClose}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: `1px solid #cfd2d6`,
                background: "#fff",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm &&
                  onConfirm({ runner, action, time, qty, dropQuantities });
                onClose();
              }}
              disabled={dropQuantities <= 0 && action === "Pickup"}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: "none",
                background:
                  dropQuantities <= 0 && action === "Pickup"
                    ? "#e0e0e0"
                    : "#10b981",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ----- Action Modal (scanner + search) ----- */
function ActionModal({
  open,
  onClose,
  type,
  runners = [],
  onSelectRunner,
  onScanResult,
}) {
  const [q, setQ] = useState("");
  const [scanValue, setScanValue] = useState("");
  const [scanning, setScanning] = useState(false);
  const [scanError, setScanError] = useState("");

  const scannerTypes = useMemo(
    () => new Set(["Scan", "Drop", "Pickup", "Drop + Pickup"]),
    []
  );

  useEffect(() => {
    if (!open) {
      setQ("");
      setScanValue("");
      setScanError("");
      setScanning(false);
    } else if (scannerTypes.has(type)) {
      setScanValue("");
      setScanError("");
      setScanning(true);
    }
  }, [open, type, scannerTypes]);

  const filtered = useMemo(() => {
    const ql = q.trim().toLowerCase();
    if (!q || q.length <= 2) return [];
    if (!ql) return runners;
    return runners.filter((r) =>
      `${r.firstName} ${r.bibNumber} ${r?.category}`.toLowerCase().includes(ql)
    );
  }, [q, runners]);

  const handleSelect = (r) => {
    onSelectRunner && onSelectRunner({ runner: r, action: type });
    onClose();
  };
  if (!open) return null;

  const handleDecode = (raw) => {
    if (!raw) return;
    let value = "";
    if (typeof raw === "string") value = raw;
    else if (raw?.text) value = raw.text;
    else if (raw?.data) value = raw.data;
    else if (raw?.toString) value = raw.toString();
    value = value.trim();

    let parsed = null;
    try {
      parsed = JSON.parse(value);
    } catch {
      parsed = null;
    }


    if (!parsed || !parsed.runnerId) {
      Snackbar.show({
        variant: "error",
        isAutoHide: true,
        preventDuplicate: true,
        message: "Invalid QR code scanned. Please scan a valid QR code.",
      });
      return;
    }

    const eventId = ApplicationUtil.getRunnersEventID();

    if (eventId != parsed.eventId) {
      Snackbar.show({
        variant: "error",
        isAutoHide: true,
        preventDuplicate: true,
        message: "Event mismatch. Please check and try again.",
      });
          onClose();
      return;
    }
    setScanValue(value);
    setScanning(false);
    onScanResult && onScanResult(value, type);
    // parent controls closing
  };

  const handleScannerError = (err) => {
    setScanError(err?.message || String(err));
    setScanning(false);
  };

  const colors = {
    grayBorder: "#cfd2d6",
    textMuted: "#6b7280",
    lightBg: "#f7f9fb",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 560,
          maxWidth: "95%",
          background: "#fff",
          borderRadius: 8,
          padding: 18,
          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        }}
      >
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {scannerTypes.has(type) ? (
            <>
              <div style={{ flex: 1, display: "flex", gap: 8 }}>
                <div
                  style={{
                    flex: 1,
                    padding: "10px 12px",
                    borderRadius: 8,
                    border: `1px solid ${colors.grayBorder}`,
                    background: "#fff",
                    color: "#111827",
                  }}
                >
                  {scanValue ? (
                    <div>
                      <div style={{ fontWeight: 700 }}>Scanned:</div>
                      <div style={{ color: colors.textMuted, marginTop: 6 }}>
                        {scanValue}
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: colors.textMuted }}>
                      Align QR code in camera to scan
                    </div>
                  )}
                </div>
                <button
                  onClick={() => {
                    setScanning(false);
                    onClose();
                  }}
                  style={{
                    padding: "10px 12px",
                    borderRadius: 8,
                    border: `1px solid ${colors.grayBorder}`,
                    background: "#fff",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            <>
              <input
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder={`Search ${type} — name, bib, category...`}
                style={{
                  flex: 1,
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: `1px solid ${colors.grayBorder}`,
                  outline: "none",
                }}
              />
              <button
                onClick={onClose}
                style={{
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: `1px solid ${colors.grayBorder}`,
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
            </>
          )}
        </div>

        <div style={{ maxHeight: 360, overflow: "auto" }}>
          {scannerTypes && scannerTypes.has(type) ? (
            <div style={{ display: "flex", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    border: `1px solid ${colors.grayBorder}`,
                    borderRadius: 8,
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "56.25%",
                    }}
                  >
                    <div style={{ position: "absolute", inset: 0 }}>
                      <QrScanner
                        onDecode={handleDecode}
                        onError={handleScannerError}
                        constraints={{ facingMode: "environment" }}
                        videoStyle={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        containerStyle={{
                          width: "100%",
                          height: "0%",
                          paddingTop: "65%",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: 8,
                    color: colors.textMuted,
                    fontSize: 13,
                  }}
                >
                  {scanError ? (
                    <div>
                      {scanError}
                      <div style={{ marginTop: 8 }}>
                        Fallback: paste QR/text value manually below.
                      </div>
                    </div>
                  ) : scanning ? (
                    <div>Scanning for QR codes...</div>
                  ) : (
                    <div>Initializing camera...</div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              {filtered.length === 0 ? (
                <div style={{ color: colors.textMuted ,  textAlign: "center",padding:"10px 0" }}>No results found.</div>
              ) : (
                filtered.map((r, i) => (
                  <div
                    key={i}
                    onClick={() => handleSelect(r)}
                    style={{
                      padding: "10px 12px",
                      borderRadius: 8,
                      marginBottom: 8,
                      cursor: "pointer",
                      border: `1px solid ${colors.grayBorder}`,
                      background: "#fff",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: 700 }}>
                        {r.name || r.firstName + " " + r.lastName}
                      </div>
                      <div style={{ color: colors.textMuted, fontSize: 13 }}>
                        Bib: {r.bibNumber || "-"} • {r?.category}
                      </div>
                    </div>
                    {/* <div style={{ textAlign: "right" }}>
                      <div style={{ color: colors.textMuted, fontSize: 12 }}>
                        {type}
                      </div>
                      <div style={{ marginTop: 6 }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect(r);
                          }}
                          style={{
                            padding: "6px 10px",
                            borderRadius: 8,
                            border: `1px solid ${colors.grayBorder}`,
                            background: colors.lightBg,
                            cursor: "pointer",
                          }}
                        >
                          {type}
                        </button>
                      </div>
                    </div> */}
                  </div>
                ))
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ----- Main Component ----- */
export default function BagManagementVolunteer({
  categories,
  role = "COMMAND_CENTER_USER",
}) {
  const [topAction, setTopAction] = useState("Drop");
  const [selectedCategory, setSelectedCategory] = useState("OverAll");
  const [activeSubTab, setActiveSubTab] = useState("Participant Information");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("Search");

  const [runners, setRunners] = useState();
  const [userActivity, setUserActivity] = useState([]);

  const [selectedRunner, setSelectedRunner] = useState();
  const fileRef = useRef(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmRunner, setConfirmRunner] = useState(null);
  const [confirmAction, setConfirmAction] = useState("");
  const [confirmTime, setConfirmTime] = useState("");
  const [categoryStats, setCategoryStats] = useState([]);
  const [render, setRender] = useState(false);

  const [dropQuantities, setDropQuantities] = useState(1);

  const topButtons = useMemo(() => {
    const level = typeof role !== "undefined" ? role : 2; // default to 2 if not provided
    const base = [
      {
        name: "BIB Scan",
        key: "Scan",
        color: "#fff",
        outline: true,
        icon: <BiScan size={23} />,
      },
      {
        name: "Search",
        key: "Search",
        color: "#fff",
        outline: true,
        icon: <LuSearch size={23} />,
      },
    ];

    const userRoles = ["VENUE_USER", "MID_WAY_USER", "COMMAND_CENTER_USER"];
    if (level === "VENUE_USER") {
      // venue user
      return [
        {
          name: "Bag Drop",
          key: "Drop",
          color: "#3a6ea5",
          icon: <LuPackage size={23} />,
        },
        {
          name: "Bag Pickup",
          key: "Pickup",
          color: "#10b981",
          icon: <LuPackageCheck size={23} />,
        },
        ...base,
      ];
    }

    if (level === "MID_WAY_USER") {
      // midway user
      return [
        {
          name: "Bag Open",
          key: "Drop + Pickup",
          color: "#f59e0b",
          icon: <GoPackageDependents size={23} />,
        },
        ...base,
      ];
    }

    return [
      {
        name: "Bag Drop",
        key: "Drop",
        color: "#3a6ea5",
        icon: <LuPackage size={23} />,
      },
      {
        name: "Bag Pickup",
        key: "Pickup",
        color: "#10b981",
        icon: <LuPackageCheck size={23} />,
      },
      {
        name: "Bag Open",
        key: "Drop + Pickup",
        color: "#f59e0b",
        icon: <GoPackageDependents size={23} />,
      },
      ...base,
      // {
      //   key: "Import",
      //   color: "#fff",
      //   outline: true,
      //   icon: <AiOutlineDownload size={23} />,
      // },
    ];
  }, [role]);

  useEffect(() => {
    const eventId = ApplicationUtil.getRunnersEventID();
    if (selectedRunner) {
      fetchRunnerDropQuantities(eventId, selectedRunner.runnerId).then(
        (res) => {
          if (res.success) {
            console.log(res, "droquanties -----");

            // parsed = res.data[0];
            setDropQuantities(res.data?.dropQuantity);
          }
        }
      );
    }
  }, []);

  const fetchRunnerDropQuantities = async (eventId, runnerId) => {
    try {
      const response = await getBagManagementParticipantsDropQuantities(
        eventId,
        runnerId
      );
      return {
        success: true,
        data: response?.data || null,
      };
    } catch (error) {
      console.log("Error fetching runner info", error);
      return {
        success: false,
        error,
      };
    }
  };

  useEffect(() => {
    const eventId = ApplicationUtil.getRunnersEventID();
    // getBagManagementParticipants(eventId)
    //   .then((res) => {
    //     const list = res.data || [];
    //     setRunners(list);

    //     if (list.length > 0) {
    //       setSelectedRunner(list[0]);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err, "Error fetching participants");
    //   });


    if (selectedCategory === "OverAll") {
      getBagManagementFiltersStatistics(eventId, "OVERALL")
        .then((res) => {
          const formattedData = formatCategoryStats(res.data);

          setCategoryStats(formattedData);
          // Update stats based on response
        })
        .catch((err) => {
          console.log(err, "Error fetching filtered stats");
        });
      setRender(false);
    }else{
         getBagManagementFiltersStatistics(eventId, selectedCategory)
        .then((res) => {
          const formattedData = formatCategoryStats(res.data);

          setCategoryStats(formattedData);
          // Update stats based on response
        })
        .catch((err) => {
          console.log(err, "Error fetching filtered stats");
        });
      setRender(false);
    }
  }, [render]);

  useEffect(() => {
    const eventId = ApplicationUtil.getRunnersEventID();
    getBagManagementParticipants(eventId)
      .then((res) => {
        const list = res.data || [];
        setRunners(list);

        if (list.length > 0) {
          setSelectedRunner(list[0]);
        }
      })
      .catch((err) => {
        console.log(err, "Error fetching participants");
      });
  }, []);

  const fetchRunnerInfo = async (eventId, runnerId) => {
    try {
      const response = await getBagManagementParticipantsInfo(
        eventId,
        runnerId
      );
      return {
        success: true,
        data: response?.data || null,
      };
    } catch (error) {
      console.log("Error fetching runner info", error);
      return {
        success: false,
        error,
      };
    }
  };

  useEffect(() => {
    if (!selectedRunner) return; // prevent undefined access

    const eventId = ApplicationUtil.getRunnersEventID();
    const runnerId = selectedRunner?.runnerId;

    if (!runnerId) return; // prevent unnecessary API call

    getBagManagementParticipantsActivities(eventId, runnerId)
      .then((res) => {
        // console.log(res, "Runner activities");
        setUserActivity(res.data || []);
      })
      .catch((err) => {
        console.log(err, "Error fetching activities");
      });
  }, [selectedRunner, activeSubTab]);

  const actionButton = (btn, active) => ({
    padding: "28px 30px",
    borderRadius: 8,
    border: btn.outline ? `1px solid #cfd2d6` : `1px solid #cfd2d6`,
    background: btn.outline ? "#fff" : btn.color,
    color: btn.outline ? "#111827" : "#fff",
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: active
      ? "0 6px 20px rgba(37,99,235,0.12)"
      : "0 1px 0 rgba(16,24,40,0.03)",
    minWidth: 110,

    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
  });

  const chip = (active) => ({
    padding: "8px 14px",
    borderRadius: 8,
    background: active ? "#3a6ea5" : "#fff",
    color: active ? "#fff" : "#111827",
    border: active ? "none" : `1px solid #cfd2d6`,
    fontWeight: 600,
    cursor: "pointer",
    marginRight: 8,
  });

  /* ----- CSV/JSON parsing ----- */
  function parseCSV(text) {
    const lines = text.split(/\r?\n/).filter(Boolean);
    if (!lines.length) return [];
    const headers = lines[0].split(",").map((h) => h.trim());
    return lines.slice(1).map((line) => {
      const cols = line.split(",").map((c) => c.trim());
      const obj = {};
      headers.forEach((h, i) => (obj[h] = cols[i] || ""));
      return {
        name: obj.firstName || obj.firstName || "Unknown",
        bib: obj.bib || obj.BIB || obj.Bib || "",
        category: obj.category || obj.Category || "Overall",
        bloodGroupId: obj.bloodGroupId || obj.bloodGroup || "",
        bloodGroup: obj.bloodGroup || obj.BloodGroup || "",
        emergencyName: obj.emergencyName || obj.EmergencyName || "",
        emergencyContact: obj.emergencyContact || obj.EmergencyContact || "",
      };
    });
  }

  function handleFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const text = ev.target.result;
      let parsed = [];
      try {
        const json = JSON.parse(text);
        parsed = Array.isArray(json) ? json : [json];
      } catch {
        parsed = parseCSV(text);
      }
      const normalized = parsed.map((r) => ({
        name: r.firstName || r.firstName || "Unknown",
        bib: r.bib || r.BIB || "",
        category: r.category || r.Category || "Overall",
        bloodGroupId: r.bloodGroupId || r.bloodGroup || "",
        bloodGroup: r.bloodGroup || r.BloodGroup || "",
        emergencyName: r.emergencyName || r.EmergencyName || "",
        emergencyContact: r.emergencyContact || r.EmergencyContact || "",
      }));
      if (!normalized.length) return;
      setRunners((prev) => {
        const merged = [...normalized, ...prev];
        setSelectedRunner(merged[0]);
        return merged;
      });
    };
    reader.readAsText(file);
    e.target.value = "";
  }

  /* ----- Modal handlers ----- */
  const openModal = (type) => {
    setModalType(type);
    setModalOpen(true);
  };

  const handleRunnerAction = ({ runner, action }) => {
    setTopAction(action);
    setSelectedRunner(runner);
    setActiveSubTab("Participant Information");
    // Optionally open confirm for non-scanner selection if needed
  };

  // scanner actions set
  const scannerActions = useMemo(
    () => new Set(["Scan", "Drop", "Pickup", "Drop + Pickup"]),
    []
  );

  // raw can be string or JSON string; action tells which button triggered scan
  const handleScanResult = async (raw, action) => {
    let parsed = null;
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = null;
    }

    let eventId = ApplicationUtil.getRunnersEventID();
    if (parsed && action === "Scan") {
      await fetchRunnerInfo(eventId, parsed.runnerId).then((res) => {
        if (res.success) {
          parsed = res.data;
        }
      });

      // return
    }

    if (!parsed) {
      Snackbar.show({
        variant: "error",
        isAutoHide: true,
        preventDuplicate: true,
        message: "No activity found.",
      });
      return;
    }

    const targetAction = action || "Scan";
    setTopAction(targetAction);

    // helper to open confirm modal with runner & action
    // const openConfirmFor = (runnerObj) => {
    //   const now = new Date();
    //   setConfirmRunner(runnerObj);
    //   setConfirmAction(targetAction);
    //   setConfirmTime(now.toLocaleString());
    //   setConfirmOpen(true);
    //   setActiveSubTab("Participant Information");
    // };

    if (parsed && parsed.runnerId) {
      let dropQuantities = 0;
      if (action !== "Scan") {
        fetchRunnerDropQuantities(eventId, parsed.runnerId).then((res) => {
          if (res.success) {
            dropQuantities = res.data?.dropQuantity;

            let runnerData = ApplicationUtil.getRunnerDetails();

            let syncObj = {
              eventId: eventId,
              runnerId: `${parsed.runnerId}`,
              scannedBy: runnerData.id,
              quantity:
                action === "Pickup"
                  ? res.data?.dropQuantity > 0
                    ? res.data?.dropQuantity
                    : 1
                  : 1,
            };

            if (action === "Pickup" && res.data?.dropQuantity === 0) {
              Snackbar.show({
                variant: "warning",
                isAutoHide: true,
                preventDuplicate: true,
                message: "No bags were dropped.",
              });
              return;
            }

            if (action === "Pickup" && res.data?.dropQuantity <= 0) {
              Snackbar.show({
                variant: "warning",
                isAutoHide: true,
                preventDuplicate: true,
                message: "Bags already picked up.",
              });
              return;
            }

            if (action === "Drop" && res.data?.dropQuantity >= 2) {
              Snackbar.show({
                variant: "warning",
                isAutoHide: true,
                preventDuplicate: true,
                message: "Maximum drop limit reached.",
              });
              return;
            }

            if (action === "Drop + Pickup" && res.data?.dropQuantity === 0) {
              Snackbar.show({
                variant: "warning",
                isAutoHide: true,
                preventDuplicate: true,
                message: "No bags were dropped.",
              });
              return;
            }

            if (action === "Drop + Pickup" && res.data?.dropQuantity < 0) {
              Snackbar.show({
                variant: "warning",
                isAutoHide: true,
                preventDuplicate: true,
                message: "Already picked up all dropped bags.",
              });
              return;
            }
            // console.log(selectedCategory);

            // if (
            //   action === "Drop + Pickup" &&
            //   res.data?.dropQuantity > 0 &&
            //   (selectedCategory === "35K" || selectedCategory === "25K")
            // ) {
            //   Snackbar.show({
            //     variant: "warning",
            //     isAutoHide: true,
            //     preventDuplicate: true,
            //     message:
            //       "Bags cannot be opened for 25K and 35K categories.",
            //   });
            //   return;
            // }

            if (action?.toString().toUpperCase() !== "SCAN") {
              syncObj.action = action?.toString().toUpperCase();
            }

            // console.log("Confirmed action:", { runner, action, time, qty }, syncObj);
            // you can update stats or runner history here
            // quick example: increment drop/pickup counters (not persisted)
            // For now, just set top action & selected runner

            postBagManagementScannedData(syncObj)
              .then((res) => {
                setRender(true);

                getBagManagementParticipants(eventId)
                  .then((res) => {
                    const list = res.data || [];

                    let currentRunner;
                    if (res.data) {
                      currentRunner = res.data.find(
                        (item) => item.runnerId === parsed.runnerId
                      );
                    }

                    setRunners(list);

                    if (list.length > 0) {
                      setSelectedRunner(currentRunner);
                    }
                  })
                  .catch((err) => {
                    console.log(err, "Error fetching participants");
                  });
                if (res.data.code === "200") {
                  Snackbar.show({
                    variant: "success",
                    isAutoHide: true,
                    preventDuplicate: true,

                    message:
                      action === "Drop"
                        ? "Baggage dropped "
                        : action === "Pickup"
                        ? "Baggage picked up"
                        : "Baggage opened",
                  });
                } else if (res.data.code === "400") {
                  Snackbar.show({
                    variant: "warning",
                    isAutoHide: true,
                    preventDuplicate: true,
                    message:
                      res.data.verbose || "Action recorded successfully.",
                  });
                }
              })
              .catch((err) => {
                console.log(err, "err");
              });
          }
        });
      }
      setTopAction(action);

      setActiveSubTab("Participant Information");

      const normalized = {
        name: parsed.name || "Unknown",
        firstName: parsed.firstName || "Unknown",
        lastName: parsed.lastName || "Unknown",
        bibNumber: parsed.bibNumber || "",
        runnerId: parsed.runnerId || "",
        contactNumber: parsed.contactNumber || "",
      };

      //  setSelectedRunner(normalized);
      setRunners((prev) => {
        const exists = prev.find((p) => p.runnerId === normalized.runnerId);
        console.log(exists);
        if (exists) {
          setSelectedRunner(exists);
          // open confirm only for scanner-originated actions
          // if (scannerActions.has(targetAction)) openConfirmFor(exists);
          return prev;
        }
        const merged = [normalized, ...prev];
        setSelectedRunner(normalized);
        // if (scannerActions.has(targetAction)) openConfirmFor(normalized);
        return merged;
      });
      return;
    }

    const trimmed = typeof raw === "string" ? raw.trim() : raw;
    const match = runners.find((r) => r.runnerId === trimmed);
    if (match) {
      setSelectedRunner(match);
      // if (scannerActions.has(targetAction)) {
      //   openConfirmFor(match);
      // }
      return;
    }

    // create quick runner if nothing matched
    const newRunner = {
      firstName: raw,
      lastName: "",
      bibNumber: raw,
      category: "Overall",
      bloodGroupId: "",
      bloodGroup: "",
      emergencyName: "",
      emergencyContact: "",
    };
    setRunners((prev) => {
      const merged = [newRunner, ...prev];
      setSelectedRunner(newRunner);
      return merged;
    });
    // if (scannerActions.has(targetAction)) {
    //   openConfirmFor(newRunner);
    // }
  };

  // on confirm action from ConfirmModal
  const handleConfirm = ({ runner, action, time, qty, dropQuantities }) => {
    // Example: log or update state / stats

    let runnerData = ApplicationUtil.getRunnerDetails();
    let eventId = ApplicationUtil.getRunnersEventID();
    let syncObj = {
      eventId: eventId,
      runnerId: `${runner.runnerId}`,
      scannedBy: runnerData.id,
      quantity: action === "Pickup" ? dropQuantities : qty,
    };

    if (action === "Drop" && dropQuantities >= 2) {
      Snackbar.show({
        variant: "warning",
        isAutoHide: true,
        preventDuplicate: true,
        message: "Maximum drop limit reached.",
      });
      return;
    }

    if (action === "Drop + Pickup" && dropQuantities < 0) {
      Snackbar.show({
        variant: "warning",
        isAutoHide: true,
        preventDuplicate: true,
        message: "Already picked up all dropped bags.",
      });
      return;
    }

    if (action?.toString().toUpperCase() !== "SCAN") {
      syncObj.action = action?.toString().toUpperCase();
    }

    // console.log("Confirmed action:", { runner, action, time, qty }, syncObj);
    // you can update stats or runner history here
    // quick example: increment drop/pickup counters (not persisted)
    // For now, just set top action & selected runner

    postBagManagementScannedData(syncObj)
      .then((res) => {
        setRender(true);

        if (res.data.code === "200") {
          Snackbar.show({
            variant: "success",
            isAutoHide: true,
            preventDuplicate: true,
            message:
              action === "Drop"
                ? "Baggage dropped."
                : action === "Pickup"
                ? "Baggage picked up."
                : "Baggage opened .",
          });
          return;
        } else if (res.data.code === "400") {
          Snackbar.show({
            variant: "warning",
            isAutoHide: true,
            preventDuplicate: true,
            message: res.data.verbose || "Action recorded successfully.",
          });
          return;
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
    setTopAction(action);
    setSelectedRunner(runner);
    setActiveSubTab("Participant Information");
  };

  /* ----- styles ----- */
  const container = {
    fontFamily: "Inter, Arial, sans-serif",
    // padding: 24,
    minHeight: "100vh",
    color: "#111827",
  };
  const topRow = {
    display: "flex",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 28,
    alignItems: "stretch",
  };
  const statCard = {
    background: "#fff",
    border: `1px solid #cfd2d6`,
    borderRadius: 8,
    padding: "16px 20px",
    minWidth: 110,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === "OverAll") category = "OVERALL";
    let eventId = ApplicationUtil.getRunnersEventID();

    getBagManagementFiltersStatistics(eventId, category)
      .then((res) => {
        const formattedData = formatCategoryStats(res.data);

        setCategoryStats(formattedData);
        // Update stats based on response
      })
      .catch((err) => {
        console.log(err, "Error fetching filtered stats");
      });
  };

  const formatCategoryStats = (data) => {
    return [
      {
        title: "Total Bags Dropped",
        value: data?.drop || 0,
        color: "#3a6ea5",
      },
      {
        title: "Total Bags Picked up",
        value: data?.pickUp || 0,
        color: "#10b981",
      },
    ];
  };

  return (
    <div style={container}>
      <div style={topRow}>
        {topButtons.map((b) => {
          const active =
            topAction === b.key && b.key !== "Search" && b.key !== "Import";
          return (
            <div
              key={b.key}
              role="button"
              onClick={() => {
                if (b.key === "Search") {
                  openModal("Search");
                  return;
                }
                if (b.key === "Import") {
                  // fileRef.current?.click();
                  return;
                }
                // For Drop / Pickup / Drop + Pickup / Scan -> open scanner modal
                openModal(b.key);
              }}
              style={actionButton(b, active)}
            >
              <div>{b.icon}</div>
              {b.name}
            </div>
          );
        })}
      </div>

      <h3 style={{ margin: "8px 0 16px" }}>Live Dashboard</h3>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        {[{ category: "OverAll", categoryName: "OverAll" }, ...categories].map(
          (c) => (
            <div
              key={c.category}
              onClick={() => {
                handleCategoryChange(c.categoryName);
              }}
              style={chip(selectedCategory === c.categoryName)}
            >
              { c.categoryName === "OverAll" ? "Overall" : c.categoryName}
            </div>
          )
        )}
      </div>

      <div
        style={{ display: "flex", gap: 16, marginBottom: 28, flexWrap: "wrap" }}
      >
        {categoryStats &&
          categoryStats.map((s) => (
            <div key={s.title} style={statCard}>
              <div style={{ color: "#6b7280", fontSize: 14, marginBottom: 8 }}>
                {s.title}
              </div>
              <div style={{ fontSize: 28, fontWeight: 700, color: s.color }}>
                {s.value}
              </div>
            </div>
          ))}
      </div>
      {selectedRunner && (
        <div style={{ display: "flex", gap: 20 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              {["Participant Information", "Activity"].map((t) => (
                <div
                  key={t}
                  onClick={() => setActiveSubTab(t)}
                  style={{
                    padding: "8px 14px",
                    borderRadius: 8,
                    background: activeSubTab === t ? "#fff" : "#f7f9fb",
                    border:
                      activeSubTab === t
                        ? `1px solid #3a6ea5`
                        : `1px solid transparent`,
                    fontWeight: activeSubTab === t ? 700 : 600,
                    cursor: "pointer",
                  }}
                >
                  {t}
                </div>
              ))}
            </div>

            <div
              style={{
                background: "#fff",
                border: `1px solid #cfd2d6`,
                borderRadius: 8,
                padding: 18,
              }}
            >
              {activeSubTab === "Participant Information" ? (
                <>
                  <div
                    style={{ display: "flex", gap: 24, alignItems: "center" }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ color: "#6b7280", marginBottom: 6 }}>
                        Name : {" "}
                         <span style={{ color: "black", fontWeight: "700" }}>
                          {selectedRunner.name ||
                            selectedRunner?.firstName +
                              " " +
                              selectedRunner?.lastName ||
                            "-"}
                        </span>
                      </div>

                      <div style={{ color: "#6b7280", marginBottom: 6 }}>
                        Category :{" "}
                        <span style={{ color: "black", fontWeight: "700" }}>
                          {selectedRunner?.category || "-"}
                        </span>
                      </div>

                      <div style={{ color: "#6b7280" }}>
                        BIB Number :{" "}
                        <span style={{ color: "black", fontWeight: "700" }}>
                          {selectedRunner?.bibNumber || "-"}
                        </span>
                      </div>
                      <div style={{ height: 12 }} />
                    </div>
                  </div>

                  <div style={{ height: 16 }} />

                  <div
                    style={{
                      borderTop: `1px dashed #cfd2d6`,
                      paddingTop: 12,
                      display: "flex",
                      gap: 24,
                    }}
                  >
                    <div style={{ color: "#6b7280", minWidth: 160 }}>
                      Emergency Name :
                    </div>
                    <div style={{ fontWeight: 700 }}>
                      {selectedRunner?.emergencyContactName
                        ? selectedRunner?.emergencyContactName
                        : selectedRunner.name ||
                          selectedRunner?.firstName +
                            " " +
                            selectedRunner?.lastName ||
                          "-"}
                    </div>
                  </div>

                  <div style={{ marginTop: 8, display: "flex", gap: 24 }}>
                    <div style={{ color: "#6b7280", minWidth: 160 }}>
                      Emergency Contact:
                    </div>
                    <div style={{ fontWeight: 700 }}>
                      {selectedRunner?.contactNumber || "-"}
                    </div>
                  </div>

                  <div style={{ marginTop: 12, display: "flex", gap: 24 }}>
                    <div style={{ color: "#6b7280", minWidth: 160 }}>
                      Blood Group (type):
                    </div>
                    <div style={{ fontWeight: 700 }}>
                      {selectedRunner?.bloodGroup || "-"}
                    </div>
                  </div>
                </>
              ) : (
                <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                  <Table style={{ marginTop: 12 }}>
                    <TableHead>
                      <TableRow>
                        {/* <TableCell>
                        <Typography
                          style={{ fontWeight: 700, color: "#374151" }}
                        >
                          Name
                        </Typography>
                      </TableCell> */}
                        <TableCell>
                          <Typography
                            style={{ fontWeight: 700, color: "#374151" }}
                          >
                            Action
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontWeight: 700, color: "#374151" }}
                          >
                            Quantity
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{ fontWeight: 700, color: "#374151" }}
                          >
                            Time
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {userActivity &&
                        userActivity
                          ?.sort((a, b) => moment(b.time).diff(moment(a.time)))
                          ?.map((r, idx) => (
                            <TableRow
                              key={idx}
                              hover
                              onClick={() => {
                                // setSelectedRunner(r);
                                // setActiveSubTab("Participant Information");
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {/* <TableCell>
                          <Typography
                            style={{ fontWeight: 600, color: "#111827" }}
                          >
                            {r.runner.firstName + " " + r.runner.lastName ||
                              "-"}
                          </Typography>
                        </TableCell> */}
                              <TableCell>
                                <Typography
                                  style={{ fontWeight: 600, color: "#111827" }}
                                >
                                  {r.action === "DROP + PICKUP" ? "OPEN" : r.action || "-"}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography
                                  style={{ fontWeight: 600, color: "#111827" }}
                                >
                                  {r.quantity || "-"}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography style={{ color: "#6b7280" }}>
                                  

                                  {moment
                                    .utc(r.time)
                                    .local()
                                    .format("YYYY-MM-DD hh:mm:ss A") || "-"}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Hidden file input for Import */}
      <input
        ref={fileRef}
        type="file"
        accept=".json,.csv,text/csv,application/json"
        style={{ display: "none" }}
        onChange={handleFile}
      />

      {/* Reusable Action / Search Modal */}
      <ActionModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        type={modalType}
        runners={runners}
        onSelectRunner={(payload) => {
          handleRunnerAction(payload);
          setModalOpen(false);
        }}
        onScanResult={(raw, action) => {
          console.log(raw, action, "sss");

          handleScanResult(raw, action);
          setModalOpen(false);
        }}
      />

      {/* Confirm modal shown after a scan resolves to a runner */}
      <ConfirmModal
        open={confirmOpen}
        onClose={() => {
          setConfirmOpen(false);
        }}
        runner={confirmRunner}
        action={confirmAction}
        time={confirmTime}
        onConfirm={handleConfirm}
      />
    </div>
  );
}
